export default __webpack_public_path__ + "fonts/d6363f8209002f967c3db8856b4d6eb8.woff";